import { Component, ChangeDetectionStrategy } from '@angular/core';

// Destino inerte da rota '/home', usada como truque de reload (navegar pra cá e
// voltar pra rota atual só pra forçar o Angular a destruir/recriar a página).
// Precisa ser um componente sem template visível — ver header.component.ts reload().
@Component({
  selector: 'app-blank',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlankComponent {}
